import { Box, Text, TextButton } from '@wix/design-system';
import { Brands } from '@wix/package-picker-common';
import * as React from 'react';
import EditorXLogo from '../../assets/logo/editor-x.svg?url';
import { useIsMobile } from '../../hooks';
import { useComponentsTranslations } from '../../providers/ComponentsTranslationsProvider';
import { WixLogo } from '../WixLogo';
import { FooterLink, FooterLinkCode } from './FooterLink';
const FooterLogo = ({ brand }) => {
    return brand === Brands.EDITOR_X ? (React.createElement("img", { src: EditorXLogo, height: "20px", alt: "editor-x-logo" })) : (React.createElement(WixLogo, { skin: "dark", height: "20px" }));
};
export const Footer = ({ brand, isLoggedIn, scrollToTop, dataHook, copyrightText: copyrightTextProp, logo: logoProp, width, borderTop, ...boxProps }) => {
    const { t } = useComponentsTranslations();
    const copyrightText = copyrightTextProp ??
        t(brand === Brands.EDITOR_X
            ? 'footer.editorx.copyright'
            : 'footer.copyright');
    const logo = logoProp ?? React.createElement(FooterLogo, { brand: brand });
    const isMobile = useIsMobile();
    if (!isLoggedIn) {
        return null;
    }
    return (React.createElement("footer", { "data-hook": dataHook, style: { width: width ?? '100%' } },
        React.createElement(Box, { paddingTop: "SP4", paddingLeft: "SP4", paddingRight: "SP4", backgroundColor: "white", borderTop: borderTop ?? '1px solid #dfe5eb', ...boxProps },
            React.createElement(Box, { direction: "vertical", width: "100%", maxWidth: "1140px" },
                React.createElement(Box, { align: "left", marginBottom: isMobile ? 'SP3' : 'SP4' }, logo),
                React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', align: "space-between" },
                    React.createElement(Text, { size: "small", weight: "normal", dataHook: "copyright-text" }, copyrightText),
                    React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', marginTop: isMobile ? 'SP5' : '0', gap: isMobile ? 'SP2' : 'SP4' },
                        Object.values(FooterLinkCode).map((footerLinkCode) => (React.createElement(FooterLink, { brand: brand, code: footerLinkCode, key: footerLinkCode }))),
                        scrollToTop && (React.createElement(TextButton, { size: "small", skin: "dark", onClick: scrollToTop, dataHook: "footer-scroll" }, t('footer.back_to_top')))))))));
};
//# sourceMappingURL=Footer.js.map